import { useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  useEffect(() => {
    // Select elements safely
    const body = document.querySelector("body");
    const mobileToggler = document.querySelector(".mobile-nav-toggler");
    const closeBtn = document.querySelector(".mobile-menu .close-btn");
    const backdrop = document.querySelector(".menu-backdrop");

    const openMenu = () => {
      body.classList.add("mobile-menu-visible");
    };

    const closeMenu = () => {
      body.classList.remove("mobile-menu-visible");
    };

    if (mobileToggler) mobileToggler.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);
    if (backdrop) backdrop.addEventListener("click", closeMenu);

    // Cleanup listeners when component unmounts
    return () => {
      if (mobileToggler) mobileToggler.removeEventListener("click", openMenu);
      if (closeBtn) closeBtn.removeEventListener("click", closeMenu);
      if (backdrop) backdrop.removeEventListener("click", closeMenu);
    };
  }, []);

  return (
    <header className="main-header header-style-one">
      {/* Header Top */}
      <div className="header-top header-top-one">
        <div className="auto-container">
          <div className="inner clearfix">
            <div className="top-left clearfix">
              <div className="top-text">
                We design and develop websites that drive real results.
              </div>
            </div>
            <div className="top-right clearfix">
              <div className="info">
                <ul className="clearfix">
                  <li className="phone">
                    <Link to="tel:416 806 6367">
                      <span className="icon sl-icon-call-in"></span>Phone{" "}
                      <strong>416 806 6367</strong>
                    </Link>
                  </li>
                  <li className="email">
                    <Link to="mailto:info@AlphaBlind.ca">
                      <span className="icon sl-icon-envelope-open"></span>
                      info@AlphaBlind.ca
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header Upper */}
      <div className="header-upper">
        <div className="auto-container">
          <div className="inner-container clearfix">
            <div className="logo-box">
              <div className="logo">
                <Link to="/">
                  <img
                    src="logo.png"
                    alt="alphablind"
                    title="alphablind"
                  />
                </Link>
              </div>
            </div>

            <div className="right-nav clearfix">
              <div className="nav-outer clearfix">
                <div className="mobile-nav-toggler">
                  <span className="icon flaticon-menu-1"></span>
                </div>

                <nav className="main-menu navbar-expand-md navbar-light">
                  <div
                    className="collapse navbar-collapse show clearfix"
                    id="navbarSupportedContent"
                  >
                    <ul className="navigation clearfix">
                      <li className="dropdown">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="dropdown">
                        <Link to="/about">About Us</Link>
                      </li>
                      <li className="dropdown">
                        <Link to="/services">Services</Link>
                      </li>
                      <li><Link to="/contact">Contact</Link></li>
                    </ul>
                  </div>
                </nav>
              </div>

              {/* <div className="search-btn">
                <button type="button" className="theme-btn search-toggler">
                  <span className="fa fa-search"></span>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        <div className="menu-backdrop"></div>
        <div className="close-btn">
          <span className="icon flaticon-targeting-cross"></span>
        </div>

        <nav className="menu-box">
          <div className="nav-logo">
            <Link to="/">
              <img src="logo.png" alt="alphablind" title="alphablind" />
            </Link>
          </div>
          <div class="menu-outer">
                                <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                    <ul class="navigation clearfix">
                                        <li class="current dropdown"><Link to="/">Home</Link>
                                        </li> 
                                        <li class="dropdown"><Link to="/about">About Us</Link></li>
                                        <li class="dropdown"><Link to="/services">Services</Link></li>


                                        <li><Link to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
